import React from 'react';
import SellerForm from './SellerForm';
import BuyerForm from './BuyerForm';

const FormsSection = ({ source = 'home', sourceCityState = '', sourceMarket = '' }) => (
  <section className="py-20 bg-slate-50" id="forms">
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">
          Get Started Today
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Ready to Take the Next Step?
        </h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          Whether you're selling your property or looking for investment opportunities, we've got you covered.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        <SellerForm source={source} defaultCityState={sourceCityState} />
        <BuyerForm source={source} defaultMarket={sourceMarket} />
      </div>
    </div>
  </section>
);

export default FormsSection;
